module.exports = __webpack_public_path__ + "static/media/HackerRank_logo.d38a06be.png";